  var shopClient = ShopifyBuy.buildClient({
      accessToken: '47031512670ac696c5a560f75ca417b9',
      domain: 'ignitiv-fire.myshopify.com',
      appId: '6'
  });

  /*
  var cart;
  shopClient.createCart().then(function (newCart) {
    cart = newCart;
    // do something with updated cart
  });

  cart.addVariants({variant: product.selectedVariant, quantity: 1}).then(function (cart) {
    // do something with updated cart
  });

  */

  var url = window.location.href;
  var userMail = $('[data-customer-id]').data("customerId");
  var userId = __st.u;
  var tenantId = 12066;
  var siteId = 16729;
  console.log(tenantId + "/" + siteId);
  console.log("Printing cust ID", userId);

  var fireMPCount = 10;
  var fireServerURL = 'https://421a4137.ngrok.io/';
  var reqUrl = null;
  if (__st.p === "product") {
    var userQuery = {};
    var currentProduct = $('.shop-product').data('product-json');
    userQuery.item = currentProduct.id;
    userQuery.num = fireMPCount;
    userQuery = encodeURIComponent(JSON.stringify(userQuery));
    reqUrl = fireServerURL + 'api/predictionio/getURRecommendedItems?userQuery=' + userQuery + '&primaryId=' + tenantId + '&secondaryId=' + siteId;
  } else {
    var userQuery = {};
    userQuery.user = userMail === undefined ? userId : userMail;
    userQuery.num = fireMPCount;
    userQuery = encodeURIComponent(JSON.stringify(userQuery));
    reqUrl = fireServerURL + 'api/predictionio/getRecommendedItems?userQuery=' + userQuery + '&primaryId=' + tenantId + '&secondaryId=' + siteId;
  }

  var list = jQuery('div.related-products');
  var recommand = [];

  //recommand = ["adidas-superstar", "apple-iphone-6", "boomerang-bag", "blur-t-shirt","black-sandle"];
  //var d = createPromises(recommand);
  //var g = promiseDone(d);

  console.log(reqUrl);
  var getRecommendedProducts = function(reqUrl) {
      $.ajax({
          headers: {
              'Content-Type': 'application/json;application/javascript;'
          },
          type: 'GET',
          url: reqUrl,
          cache: false,
          timeout: 60000,
          dataType: "JSONP",
          success: function(response) {
              console.log(response);
              var items = [];
              response = $.parseJSON(response);
              _.each(response.itemScores, function(itemScore) {
                  items.push(itemScore.item);
              });
              var productrep = [];
              var product = null;
              for (var i = 0; i < items.length; i++) {
                  productrep.push(fetchProduct(items[i]));
              }
              return promiseDone(productrep);
          },
          error: function(jqXHR, textStatus, errorThrown) {
              console.log(errorThrown);
          }
      });
  };

  getRecommendedProducts(reqUrl);

  //getURRecommendedItems(reqUrl);
  
  var cart = null;
  Shopify.getCart(function(data){ 
    cart = data; 
    console.log("Cart : " + cart); 
  });
  
  function createPromises(recommand) {
      var productrep = [];
      var product = null;
      for (var i = 0; i < recommand.length; i++) {
          productrep.push(fetchProduct(recommand[i]));
      }
      return productrep;
  }

  // fetch a product using resource id
  function fetchProduct(id) {
      return shopClient.fetchProduct(id)
          .then(function(product) {
              console.log(product);
              list.append('<div class="product-container"><div class="image-container"><a href="/products/' + product.title.toString().split(" ").join("-") + '" onclick="saveItemDetailsInROI(event)"  data-ign-fire-product-code="'+ product.selectedVariant.id + '" data-ign-fire-product-view="/products/' + product.title.toString().split(" ").join("-") + '"><img class="image" src="' + product.selectedVariant.image.src + '" /></a></div><h4><a href="/products/' + product.title.toString().split(" ").join("-") + '" onclick="saveItemDetailsInROI(event)" data-ign-fire-product-code="'+ product.selectedVariant.id + '" data-ign-fire-product-view="/products/' + product.title.toString().split(" ").join("-") + '">' + product.title + '</a></h4><span class="money">' + Shopify.formatMoney(product.variants[0].price) + '</span><button class="fire-cart-button" data-product-code="' + product.selectedVariant.id + '">addToCart</button></div>');
              return product;
          })
          .catch(function() {
              console.log('Request failed');
          });
  };

  function promiseDone(productrep) {
      return Promise.all(productrep).then(function(response) {
          console.log(response);
          list.owlCarousel({
              autoplay: false,
              responsiveClass: true,
              loop: true,
              //Mouse Events
              touchDrag: true,
              navText: [
                  "<span class='glyphicon glyphicon-chevron-left'></span>",
                  "<span class='glyphicon glyphicon-chevron-right'></span>"
              ],
              responsive: {
                  0: {
                      items: 1,
                      loop: true,
                      stagePadding: 50,
                      nav: false
                  },
                  480: {
                      items: 3,
                      nav: false,
                      loop: true,
                      stagePadding: 50
                  },
                  1025: {
                      items: 5,
                      nav: true
                  }
              }
          });

      });
  }

  function saveItemDetailsInROI(e) {
    e.preventDefault();
    var $currentTarget = $(e.currentTarget);
    var productURL = $currentTarget.context.dataset.ignFireProductView;
    var productCode = $currentTarget.context.dataset.ignFireProductCode;
    setCookie("roidataactions", productURL.replace("/products/", "/"), 30, null);
    window.location.href = productURL;
  }

  function fireROIatcEventCall(cartObj) {
      /* IGN collect data script - STARTS */
      for (var i = 0; i < window.dataLayer.length; i++) {
        delete window.dataLayer[i].atcObject;
      }

      var customerEmail = userMail === undefined ? userId : userMail;
      var atcObject = {};
      atcObject.currentCustomer = customerEmail;
      atcObject.currentProductCode = cartObj.product_id;
      atcObject.cartId = cart.token;
      atcObject.cartItemId = cartObj.id;
      atcObject.creationDate = new Date();
      atcObject.tenantId = tenantId;
      atcObject.siteId = siteId;
      window.dataLayer.push({'atcObject': atcObject});

      window.dataLayer.push({'event':'roiAddToCartProductEvent'});

      setCookie("isROIItemsAdded", 1, 30, "checkout.shopify.com");
      localStorage.setItem("isROIItemsAdded", 1);

      /* IGN collect data script - ENDS */
  }

      
	$(document).on("click", ".fire-cart-button", function(e) {
      var productId = $(e.currentTarget).attr('data-product-code');
      e.preventDefault();
      jQuery.ajax({
        url: '/cart/add.js', 
        contentType: 'application/json; charset=UTF-8',
        data: JSON.stringify({quantity: 1,id: productId}),
        dataType: "json",
        type: "post",
        success: function(cartObj) {

          console.log("Success: ", cartObj);

          fireROIatcEventCall(cartObj);

        },
        error: function (error) {
          console.log("Error: " , error);
        }
      });
    });
